import { UserAvatarComponent } from '@app/shared/components/user-avatar/user-avatar.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, Input, Renderer2, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { relationshipStoreActions, RootStoreState } from '@app/root-store';
import { selectMySuggestions } from '../../../../root-store/relationship-store/relationship.selector';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { UserConnectionService } from '@app/shared/services/user_connection/user-connection.service';
import { ConnectUserComponent } from '@app/shared/component/connect-user/connect-user.component';
import { MutualConnectionComponent } from '@app/shared/component/network-setup/mutual-connection/mutual-connection.component';
import { ToastrService } from 'ngx-toastr';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { TruncateStrPipe } from '@app/shared/pipes/truncate-str.pipe';
import { SharedCheckboxComponent } from '@app/shared/component/shared-checkbox/shared-checkbox.component';

import { FormsModule } from '@angular/forms';
import {
  SharedFloaterAction,
  SharedFloaterActionComponent
} from '@app/shared/component/shared-floater-action/shared-floater-action.component';
import { SharedFloaterPosition } from '@app/shared/component/shared-floater-action/shared-floater-position';
import { SharedActionMenuComponent, SharedMenuItemConfig } from '@app/shared/component/shared-action-menu/shared-action-menu.component';
@AutoUnsubscribe()
@Component({
    selector: 'mynetwork-suggestions',
    templateUrl: './mynetwork-suggestions.component.html',
    styleUrl: './mynetwork-suggestions.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[
    SharedCheckboxComponent,
      CommonModule,
      FormsModule,
      TitleCasePipe,
      UserAvatarComponent,
      TruncateStrPipe,
      SharedFloaterActionComponent,
      SharedActionMenuComponent
    ]
})
export class MynetworkSuggestionsComponent implements OnInit, OnDestroy {
  readonly embeddedFloaterPosition: SharedFloaterPosition = { embedded: true };

  readonly suggestionsFloaterActions: SharedFloaterAction[] = [
    { id: 'add', label: 'Add', icon: 'person_add', iconOutlined: true },
    { id: 'remove', label: 'Remove', icon: 'remove_circle', iconOutlined: true }
  ];

  @Output() moveToNextStepEmitter = new EventEmitter<void>();
  @Input() isFromNetworkSetup: boolean = false;
  @Input() switchFromUser: boolean = false;
  @Input() hideHeaderAndControls: boolean = false;
  subscription = new Subscription();
  mySuggestions$: any;
  mySuggestions: any[] = [];
  mySuggestionIds: any[] = [];
  filteredSuggestions: any[] = [];
  searchTerm: string = '';
  searchtext: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  mutualConnectionsMap: Map<string, number> = new Map();
  selectedSuggestions: any[] = [];
  selectAll: boolean = false;
  currentUser: any;
  constructor(
    private store: Store,
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog,
    private _userConnectionService: UserConnectionService,
    private _store$: Store<RootStoreState.State>,
    private UserConnection: UserConnectionService,
    private _toastr: ToastrService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    // Get current user
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
      })
    );

    this.mySuggestions$ = this.store.select(selectMySuggestions);
    this._store$.dispatch(new relationshipStoreActions.MySuggestions());
    this.subscription.add(
      this.mySuggestions$.subscribe((data) => {
        this.mySuggestions = data || [];
        this.mySuggestionIds = data?.map((item) => item.id).filter((id) => id !== null && id !== undefined) || [];
        this.applyFiltersAndSort();
        this.loadMutualConnections();
        this._cd.detectChanges();
      })
    );
    this.loadGoogleFonts();
  }

  onSearchChange() {
    this.applyFiltersAndSort();
    this._cd.detectChanges();
  }
  clearSearchAction() {
    this.searchtext = '';
    this._cd.detectChanges();
  }
  toggleSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.applyFiltersAndSort();
    this._cd.detectChanges();
  }

  applyFiltersAndSort() {
    // Apply search filter
    let filtered = this.mySuggestions;
    if (this.searchTerm.trim()) {
      filtered = this.mySuggestions.filter((suggestion) => suggestion.name?.toLowerCase().includes(this.searchTerm.toLowerCase()));
    }

    // Apply sorting
    filtered = [...filtered].sort((a, b) => {
      const nameA = a.name?.toLowerCase() || '';
      const nameB = b.name?.toLowerCase() || '';

      if (this.sortDirection === 'asc') {
        return nameA.localeCompare(nameB);
      } else {
        return nameB.localeCompare(nameA);
      }
    });

    this.filteredSuggestions = filtered;
  }

  private getSuggestionKey(item: any) {
    return item?.id ?? item?.user_id;
  }

  mutualConnection(user: any) {
    this._dialog.open(MutualConnectionComponent, {
      width: '400px',
      data: user,
    });
  }
  loadMutualConnections() {
    this.mySuggestions.forEach((suggestion) => {
      if (suggestion.id && !this.mutualConnectionsMap.has(suggestion.id)) {
        this.subscription.add(
          this.UserConnection.getMutualConnections(suggestion.id).subscribe((data) => {
            this.mutualConnectionsMap.set(suggestion.id, data.length);
            this._cd.markForCheck();
          })
        );
      }
    });
  }

  getMutualConnectionsCount(suggestion: any): number {
    return this.mutualConnectionsMap.get(suggestion.id) || 0;
  }
  acceptRequest(user: any): void {
    const modalRef = this._dialog.open(ConnectUserComponent, {
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
      data: {
        fromAddVault: true,
        selectedUser: user,
        requestForAddedUserData: true,
      },
    });

    this.subscription.add(
      modalRef.afterClosed().subscribe((data: any) => {
        if (data === 'clear') {
          return;
        }
        if (data) {
          this._toastr.success('Request sent successfully');
          this._store$.dispatch(new relationshipStoreActions.AllRelationships());
          this._store$.dispatch(new relationshipStoreActions.MySuggestions());
          this._cd.markForCheck();
        }
      })
    );
  }

  suggestionMenuItems(suggestion: any): SharedMenuItemConfig[] {
    return [
      {
        label: 'Remove Suggestion',
        icon: 'remove_circle_outline',
        action: () => this.removeSuggestions(suggestion),
        destructive: true,
      },
    ];
  }

  removeSuggestions(userOrIds: any) {
    const userIds = Array.isArray(userOrIds) ? userOrIds : [userOrIds.id];

    const sharedDialogRef = this._dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: userIds.length > 1 ? `Remove All Suggestions` : `Remove Suggestion`,
        materialIcon: userIds.length > 1 ? 'remove-info' : 'info_outline',
        text: userIds.length > 1 ? `Are you sure you want to remove all network suggestions?` : `Are you sure you want to remove this suggestion?`,
        proceedTitle: 'Remove',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this._userConnectionService.mySuggestionRemove(userIds).subscribe(() => {
              this._store$.dispatch(new relationshipStoreActions.AllRelationships());
              this._cd.markForCheck();
            })
          );
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  onSelectAllChange(event: any) {
    const isChecked = !!event?.checked;
    this.selectAll = isChecked;
    const ids = new Set((this.filteredSuggestions || []).map((s) => this.getSuggestionKey(s)));
    this.mySuggestions = (this.mySuggestions || []).map((s: any) => (ids.has(this.getSuggestionKey(s)) ? { ...s, selected: isChecked } : s));
    this.applyFiltersAndSort();
    this.selectedSuggestions = (this.filteredSuggestions || []).filter((s: any) => s?.selected);
    this._cd.markForCheck();
    this._cd.detectChanges();
  }

  onSuggestionSelectChange(suggestion: any, event: any) {
    const checked = !!event?.target?.checked || !!event?.checked;
    const key = this.getSuggestionKey(suggestion);
    this.mySuggestions = (this.mySuggestions || []).map((s: any) => (this.getSuggestionKey(s) === key ? { ...s, selected: checked } : s));
    this.applyFiltersAndSort();
    const total = (this.filteredSuggestions || []).length;
    const selected = (this.filteredSuggestions || []).filter((s: any) => s?.selected).length;
    this.selectAll = total > 0 && selected === total;
    this.selectedSuggestions = (this.filteredSuggestions || []).filter((s: any) => s?.selected);
    this._cd.markForCheck();
    this._cd.detectChanges();
  }

  onFloaterActionClick(actionId: string): void {
    this.onFloaterAction({ action: actionId });
  }

  onFloaterAction(e: { action: string }) {
    switch (e?.action) {
      case 'add': {
        const selected = this.selectedSuggestions || [];
        if (!selected.length) {
          return;
        }
        const userIds = selected.map((u: any) => u?.id ?? u?.user_id).filter((id: any) => !!id);
        if (userIds.length === 0) {
          return;
        }

        // If only one user, connect directly using connectToUser
        if (userIds.length === 1) {
          const userId = userIds[0];
          const connectionData = {
            relationship_name: undefined,
            to_user_id: userId,
            user_id: this.currentUser?.id,
            requested_user_id: userId,
            relationship_id: 118, 
            status: 'approved',
          };

          this.subscription.add(
            this.UserConnection.connectToUser(connectionData).subscribe(
              (res) => {
                // Send notification for this connection
                this.subscription.add(this.UserConnection.sendRelationshipRequestNotification(connectionData).subscribe());
                this.clearSelection();
                this._store$.dispatch(new relationshipStoreActions.AllRelationships());
                this._toastr.success('Request sent successfully');
                this._cd.markForCheck();
              },
              (err) => {
                console.error('Error connecting to user:', err);
                this.clearSelection();
                this._cd.markForCheck();
              }
            )
          );
        } else {
          // Multiple users - use connectMultipleUsers
          this.subscription.add(
            this.UserConnection.connectMultipleUsers(userIds).subscribe(
              () => {
                this.clearSelection();
                this._store$.dispatch(new relationshipStoreActions.AllRelationships());
                this._cd.markForCheck();
              },
              () => {
                this.clearSelection();
                this._cd.markForCheck();
              }
            )
          );
          this.connectMultipleUsersWithNotifications(selected);
        }
        break;
      }
      case 'remove': {
        const ids = (this.selectedSuggestions || []).map((s: any) => s?.id).filter(Boolean);
        if (!ids.length) {
          return;
        }
        this.removeSuggestions(ids);
        this.clearSelection();
        break;
      }
      case 'close':
      default:
        this.clearSelection();
        break;
    }
  }

  private clearSelection() {
    this.mySuggestions = (this.mySuggestions || []).map((s: any) => ({ ...s, selected: false }));
    this.applyFiltersAndSort();
    this.selectedSuggestions = [];
    this.selectAll = false;
    this._cd.markForCheck();
    this._cd.detectChanges();
  }

  /**
   * Get filtered suggestions based on search text
   */
  getFilteredSuggestions(): any[] {
    if (!this.filteredSuggestions || this.filteredSuggestions.length === 0) {
      return [];
    }

    if (!this.searchtext || this.searchtext.trim() === '') {
      return this.filteredSuggestions;
    }

    const searchTerm = this.searchtext.toLowerCase().trim();
    return this.filteredSuggestions.filter((suggestion: any) => {
      const name = suggestion.name ? suggestion.name.toLowerCase() : '';
      return name.includes(searchTerm);
    });
  }

  /**
   * Get count of filtered suggestions
   */
  getFilteredSuggestionsCount(): number {
    return this.getFilteredSuggestions().length;
  }

  /**
   * Connect multiple users with notifications
   */
  private connectMultipleUsersWithNotifications(selected: any[]) {
    if (!selected || !selected.length || !this.currentUser) {
      return;
    }

    // Fire all connection requests without waiting
    selected.forEach((suggestion: any) => {
      const userId = suggestion?.id ?? suggestion?.user_id;
      if (!userId) {
        return;
      }

      const connectionData = {
        relationship_name: undefined,
        to_user_id: userId,
        user_id: this.currentUser.id,
        requested_user_id: userId,
        relationship_id: 118, // Default relationship ID
      };

      // Fire and forget - don't wait for response
      this.subscription.add(
        this.UserConnection.connectToUser(connectionData).subscribe(
          (res) => {
            // Send notification for this connection
            this.subscription.add(this.UserConnection.sendRelationshipRequestNotification(connectionData).subscribe());
            
          },
          (err) => {
            console.error(`Error connecting to ${suggestion.name}:`, err);
          }
        )
      );
    });

    // Show success message immediately
    this._toastr.success('Request(s) sent successfully');

    // Refresh the network data
    this._store$.dispatch(new relationshipStoreActions.AllRelationships());
    this.clearSelection();
    this._cd.markForCheck();
  }
  loadGoogleFonts() {
    const link = this.renderer.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0';
    link.rel = 'stylesheet';
    this.renderer.appendChild(document.head, link);
  }
}
